// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__SHo1z","header":"ReportDetails_header__1Chup","title":"ReportDetails_title__ZgGLa","left":"ReportDetails_left__smrRm"};